import type { FaireProductEntity } from "../../entity_types/product";

export const p_v6zvcj3yup: FaireProductEntity = {
  token: "p_v6zvcj3yup",
  type: "product",
  name: "Cocomoi Body Mist | Half Case",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/be7215f8bc8bff94ff26b51ccc83e494d9110f8fa4c8c4b5381980c977befd58.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/34804ec9967ff8389391d9a33bcc518d50106d9d13bbb4376bc4e6db5162b3f6.webp",
    "https://cdn.faire.com/fastly/4f8a4a8a4ca849c11ca9901b705b5e3eb7eb8222de7815db98264203d3a6d972.jpeg",
    "https://cdn.faire.com/fastly/6c3c23dafa5b1850f01a80834e83197788960f4b503ffc7ed1c7b9add3306172.jpeg",
    "https://cdn.faire.com/fastly/672974f2b38a60d8a6e745841b884147504f08f2522d5a667e3cb3cfea20147e.webp",
  ],
  priceDollars: 21.66,
  description:
    "Refresh your senses with Homecourt’s Luxury Body Mist, a delicate fine fragrance spray designed to envelop skin in a light yet lasting scent. Perfect for a midday pick-me-up or as an added layer to your fragrance routine, this refreshing body mist offers a subtle, buildable aroma that lingers beautifully throughout the day.\n\nCrafted with eco-friendly, sustainably sourced ingredients, it combines luxury scent with mindful design—making it an effortless way to elevate your everyday ritual.\n\n𝗪𝗵𝘆 𝗬𝗼𝘂’𝗹𝗹 𝗟𝗼𝘃𝗲 𝗜𝘁\n• Fine fragrance body mist with a light, refreshing touch\n• Buildable scent—reapply for adjustable intensity\n• Made with eco-friendly, sustainable ingredients\n• Lightweight spray for easy, all-day use\n• Long-lasting fragrance that enhances your personal scent wardrobe\n\nCocomoi\nCoconut water, cedarwood, creamy fig, cardamom, vetiver, and black pepper. Warm, grounded, and beach-inspired.\nNotes: Coconut Water, Cedarwood*, Vetiver*, Cardamom*, Black Pepper*\n\n*indicates eco-friendly and/or sustainably sourced ingredients\n\n\n𝗛𝗼𝘄 𝘁𝗼 𝗨𝘀𝗲\nSpray lightly onto skin from a few inches away. Reapply as desired throughout the day for a refreshing burst of fragrance.\n\n𝗦𝗶𝘇𝗲\n3.4 fl oz / 100 ml\n\n𝗣𝗮𝗶𝗿𝗶𝗻𝗴 𝗥𝗲𝗰𝗼𝗺𝗺𝗲𝗻𝗱𝗮𝘁𝗶𝗼𝗻\nLayer with Homecourt’s Body Wash and Body Butter for a complete body care ritual that cleanses, hydrates, and scents skin from morning to night.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:21.937Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
